import React from "react";
import { Link } from "react-router-dom";
import InnerHero from "../../../components/InnerHero";
import {
  ArrowLeft,
  Images,
  BrainCircuit,
  Cpu,
  Database,
} from "lucide-react";

const infrastructureImages = [
  {
    src: "/Infrastructure/AIML/1.png",
    alt: "Computer Science and Engineering AI and ML laboratory",
  },
  {
    src: "/Infrastructure/AIML/2.png",
    alt: "AI and ML department infrastructure",
  },
  {
    src: "/Infrastructure/AIML/3.png",
    alt: "AI and ML computing facility",
  },
  {
    src: "/Infrastructure/AIML/4.png",
    alt: "AI and ML learning space",
  },
];

const facilities = [
  "AI Laboratory",
  "Machine Learning Laboratory",
  "Data Science Laboratory",
  "C Programming Laboratory",
  "Internet Connectivity",
  "Python Programming Lab",
  "Smart Classrooms",
  "Seminar & Presentation Facilities",
];

const AIMLInfrastructure = () => (
  <main>
    <InnerHero
      title="CSE (AI & ML) Infrastructure"
      image="/Infrastructure/AIML/1.png"
      breadcrumbs={[
        { label: "Academics", to: "/academics" },
        { label: "CSE (AI & ML)", to: "/programme/cse-aiml" },
        { label: "Infrastructure" },
      ]}
    />

    <section className="bg-surface-alt/60 border-b border-brand/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 text-xs font-sans-ui font-semibold tracking-wider text-brand">
        <Link
          to="/programme/cse-aiml"
          className="inline-flex items-center gap-2 uppercase hover:underline"
        >
          <ArrowLeft size={14} />
          Back to CSE (AI & ML)
        </Link>
      </div>
    </section>

    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-10">
          <section>
            <div className="flex items-end justify-between gap-4 mb-5">
              <div>
                <h2
                  className="text-2xl md:text-3xl text-brand font-semibold flex items-center gap-2"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  <Images size={22} />
                  Infrastructure Gallery
                </h2>

                <p className="text-sm text-[#3a3a3a]/80 italic mt-1">
                  AI, ML, computing facilities, and learning spaces
                </p>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-4">
              {infrastructureImages.map((image) => (
                <figure
                  key={image.src}
                  className="bg-white border border-brand/15 overflow-hidden"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                </figure>
              ))}
            </div>
          </section>

          <section>
            <h2
              className="text-2xl md:text-3xl text-brand font-semibold flex items-center gap-2 mb-5"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              <BrainCircuit size={22} />
              Facilities
            </h2>

            <div className="bg-white border border-brand/15 p-5">
              <ul className="grid md:grid-cols-2 gap-x-6 gap-y-2 pl-5 list-disc text-sm text-[#2a2a2a]/85 leading-relaxed">
                {facilities.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </section>
        </div>

        <aside className="space-y-5">
          <div className="bg-white border border-brand/15 p-5 lg:sticky lg:top-36 self-start">
            <h4 className="text-xs uppercase tracking-widest text-brand font-semibold">
              Infrastructure Facts
            </h4>

            <div className="mt-3 space-y-3 text-sm">
              <div className="flex items-center gap-2">
                <Cpu size={14} className="text-brand" />
                <span>
                  Laboratories: <strong>06</strong>
                </span>
              </div>

              <div>
                AI Lab: <strong>Available</strong>
              </div>

              <div>
                ML Lab: <strong>Available</strong>
              </div>

              <div>
                Data Science Lab: <strong>Available</strong>
              </div>

             
            </div>

            <Link
              to="/programme/cse-aiml"
              className="block mt-5 text-center bg-brand text-surface py-2.5 text-sm font-semibold hover:bg-brand-dark transition"
            >
              Department Overview
            </Link>

            <div className="mt-6 pt-5 border-t border-brand/10">
              <h4 className="text-xs uppercase tracking-widest text-brand font-semibold mb-3">
                Key Facilities
              </h4>

              <ul className="space-y-1.5 text-sm text-[#2a2a2a]">
                {[
                  "AI Lab",
                  "Machine Learning Lab",
                  "Data Science Lab",
                  "C Programming Lab",
                  "Data Structure Lab",
                  "Python Programming Lab",
                ].map((item) => (
                  <li key={item} className="flex items-center gap-1">
                    <Database size={12} className="text-brand" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </aside>
      </div>
    </section>
  </main>
);

export default AIMLInfrastructure;
